import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9aea6506"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "img-wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Корзина", -1))

import getImage from '@/tools/getImage';

export default /*#__PURE__*/_defineComponent({
  __name: 'CartLink',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
    to: {name: 'cart'}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_1, [
          _createElementVNode("img", {
            src: _unref(getImage)('cart-icons.webp'),
            alt: "cart image"
          }, null, 8, _hoisted_2)
        ]),
        _hoisted_3
      ])
    ]),
    _: 1
  }))
}
}

})